var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.debugMode ? 'DebugLayout' : 'Layout', {
    tag: "component"
  }, [_c('div', {
    class: _vm.$style.viewContainer
  }, [_vm.loading || _vm.error ? _c('LoaderIcon', {
    attrs: {
      "error": _vm.error
    }
  }) : _c('div', [_c('div', {
    class: _vm.$style.breadcrumbs
  }, [_c('RouterLink', {
    attrs: {
      "to": {
        name: 'leaderboards'
      }
    }
  }, [_c('MottoIcon', {
    staticClass: "cursor-pointer",
    class: _vm.$style.backButton,
    attrs: {
      "name": "Arrow",
      "icon-color": "gray"
    }
  })], 1), _c('RouterLink', {
    attrs: {
      "to": {
        name: 'leaderboards'
      }
    }
  }, [_c('p', {
    staticClass: "p2 color-darkest-gray cursor-pointer"
  }, [_vm._v("LEADERBOARDS")])]), _c('BaseIcon', {
    staticClass: "color-gray",
    attrs: {
      "name": "chevron-right"
    }
  }), _c('p', {
    staticClass: "button-text color-primary-blue",
    class: _vm.$style.selectedBreadcrumb
  }, [_vm._v("MY RANKINGS")])], 1), _c('div', {
    staticClass: "d-flex mb-30 justify-content-between align-items-center"
  }, [_c('h2', {
    staticClass: "color-primary-blue mb-0",
    class: _vm.$style.myRankingTitle
  }, [_vm._v("My Rankings")]), !_vm.isRankingEmpty ? _c('BaseSelect', {
    class: _vm.$style.leaderboardCategoriesSelect,
    attrs: {
      "name": "leaderboardCategory",
      "options": ['All'].concat(_vm.getLeaderboardCategories),
      "data-my-rankings-leaderboard-select": ""
    },
    on: {
      "update": _vm.selectLeaderboardCategory
    }
  }) : _vm._e()], 1), _vm.isRankingEmpty ? _c('div', [_c('div', {
    staticClass: "text-center"
  }, [_c('h1', {
    staticClass: "color-primary-blue"
  }, [_vm._v("Keep Going!")]), _c('h4', {
    staticClass: "color-primary-blue"
  }, [_vm._v("Once you close your first Motto loan, you'll be ranked in the Network!")])])]) : _vm._e(), !_vm.isRankingEmpty ? _c('div', {
    ref: "gridContainer",
    class: _vm.$style.myRankingsContainer
  }, _vm._l(_vm.getMyRankingsData, function (periodLeaderboard, period, index) {
    return _c('div', {
      key: index,
      staticClass: "d-contents"
    }, _vm._l(_vm.filterPeriodLeaderboardBySelectedLeaderboardCategory(periodLeaderboard), function (leaderboardDataList, leaderboardCategoryName, indexPeriodLeaderboard) {
      return _c('div', {
        key: indexPeriodLeaderboard,
        attrs: {
          "data-my-rankings-block": ""
        }
      }, [_c('div', {
        staticClass: "d-flex justify-content-between",
        class: _vm.$style.myRankingsBlockHeader
      }, [_c('h3', {
        staticClass: "color-primary-blue"
      }, [_vm._v(_vm._s(leaderboardCategoryName))]), _c('h4', {
        attrs: {
          "data-my-ranking-block-period": ""
        }
      }, [_vm._v(_vm._s(period))])]), _vm._l(leaderboardDataList, function (leaderboardData, leaderboardDataIndex) {
        return _c('LeaderboardPosition', {
          key: leaderboardDataIndex,
          class: _vm.$style.leaderboardPosition,
          attrs: {
            "leaderboard-data": leaderboardData,
            "leaderboard-position": leaderboardData.rank,
            "highlight": _vm.isMyRank(leaderboardData),
            "small-theme": true
          }
        });
      })], 2);
    }), 0);
  }), 0) : _vm._e()])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }